import { useState } from "react";
import { motion } from "framer-motion";
import { Lock, Loader2 } from "lucide-react";
import { admin, setToken, apiError } from "@/lib/admin";

export const AdminLogin = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await admin.post("/auth/login", { password });
      setToken(data.token);
      onSuccess();
    } catch (err) {
      setError(apiError(err, "Login failed."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="admin-login">
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-sm border border-gold/25 bg-ink p-10"
      >
        <div className="absolute -inset-px border border-gold/15 translate-x-3 translate-y-3 pointer-events-none" />
        <Lock size={20} strokeWidth={1.25} className="text-gold" />
        <h1 className="mt-5 font-serif text-3xl text-ivory">Leads dashboard</h1>
        <p className="mt-2 text-sm text-ivory/50">Private — Bossard Investment Group</p>
        <label className="block mt-8">
          <span className="eyebrow">Password</span>
          <input
            type="password"
            required
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-transparent border-b border-ivory/20 focus:border-gold outline-none py-3 text-ivory transition-colors"
            data-testid="admin-password-input"
          />
        </label>
        {error && (
          <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={busy}
          className="btn-gold mt-8 w-full inline-flex items-center justify-center gap-3 bg-gold text-obsidian text-xs tracking-[0.2em] uppercase py-4 disabled:opacity-60"
          data-testid="admin-login-btn"
        >
          {busy && <Loader2 size={14} className="animate-spin" />} Sign in
        </button>
      </motion.form>
    </div>
  );
};
